// --- Navs ---

const navsContainer = document.getElementById('navsContainer');
const navsTogglers = document.querySelectorAll('#navsContainer [data-bs-target]');

if(navsContainer) {
    navsContainer.addEventListener('show.bs.collapse', function (e) {
        let toggler = document.querySelector('#navsContainer [data-bs-target="#' + e.target.id + '"]');
    
        navsTogglers.forEach((element) => {
            element.classList.remove('active');
        });
    
        toggler.classList.add('active');

        console.log(window.screen.availWidth);
        if(window.screen.availWidth < 786) {
            document.querySelector('.navs-wrapper').scrollIntoView();
        }
    });
}